// extracted by mini-css-extract-plugin
var _1 = "CursorSelection-module__color1--aa_nW";
var _2 = "CursorSelection-module__color2--SGjl4";
var _3 = "CursorSelection-module__color3--Zscsk";
var _4 = "CursorSelection-module__color4--gtaHD";
var _5 = "CursorSelection-module__color5--TBUMZ";
var _6 = "CursorSelection-module__color6--fZKGq";
var _7 = "CursorSelection-module__container--V2o3z";
var _8 = "CursorSelection-module__embed--WxODc";
var _9 = "CursorSelection-module__hr--HYkM8";
var _a = "CursorSelection-module__innerContainer--f9DiU";
var _b = "CursorSelection-module__selection--SaxlP";
export { _1 as "color1", _2 as "color2", _3 as "color3", _4 as "color4", _5 as "color5", _6 as "color6", _7 as "container", _8 as "embed", _9 as "hr", _a as "innerContainer", _b as "selection" }
